import React, { Component, useEffect, useState, useRef } from "react";
import DialCode from '../PaymentDetails/DialCode';
import "./Subagents.css";
import { Helmet } from "react-helmet";
import NewHeader from "../NewHeader/NewHeader";
import { Base64 } from "js-base64";
import { useForm } from "react-hook-form";
import { setUserAgentRegister, getGeoInfo, getUserAgentListing, setUserAgentSoftDeleteData } from "../axios";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import Spinner from 'react-bootstrap/Spinner';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
  export default function Agentuser() {

    const [Newcountry, setCountry] = useState({});
    const [countrycode, setCountryCode] = useState({});
    const [Newcurrency, setCurrency] = useState({});
    const [ipaddress, setIpaddress] = useState({});
    const [sussessRegister, setSussessRegister] = useState(false);
    const [EmailRecheck, setEmailRecheck] = useState(false);
    const [PasswordMatchcheck, setPasswordMatchcheck] = useState(false);
    const [btnloader, setbtnloader] = useState(0);
    const [MobileCode, setMobileCode] = useState("");
    const [customerid, setCustomerid] = useState("");
    const [agentUserData, setAgentUserData] = useState(null);
    const [DisablePayNowButton, setDisablePayNowButton] = useState(false);
    const {
      register,
      handleSubmit, watch,
      formState: { errors },
    } = useForm({
      mode: "onChange",
    });

      useEffect(() => {
        const userArr = localStorage.getItem("userDetails");
        const userArrNew = JSON.parse(userArr);
        const customer_id = userArrNew?.agent_id;
        getGeoInfo().then(
            (data) => {
                setCountry(data.country_name);
                setCountryCode(data.country_calling_code);
                setCurrency(data.country_name);
                setIpaddress(data.ip);
            },
            (error) => {}
          );
          setCustomerid(customer_id);

          getUserAgentListing(customer_id).then(
            (data) => {
              setAgentUserData(data);
            },
            (error) => {}
          );

      }, []);
      
     
      let OnChangeMobileCode = (event) => {
      
        setMobileCode(event.target.value);
      };
       const password = useRef({});
          password.current = watch("password", "");   

          const onSubmit = (data) => {
          
            let subData = true;
            setbtnloader(1);
            setTimeout(() => {
              if (subData) {
                  setSussessRegister(false);
                  setDisablePayNowButton(true);
                var MobileCodeData = MobileCode != ''? MobileCode: countrycode;
                  let first_name = data.firstName;
                  let last_name = data.lastName;
                  let email = data.email;
                 let mobile_number = data.number;
                 let country_code = MobileCodeData;
                 let password = data.password;
                 let checkdata = data.checkdata;
                 let customer_agent_id = customerid;
               
                 setUserAgentRegister(first_name, last_name, email, mobile_number, country_code,  password, customer_agent_id, checkdata).then(
                  (data) => {
                   
                     if(data !='exist'){
                      setSussessRegister(true);
                      window.location.reload(true); 
                      setbtnloader(0);
                     }else{
                      setbtnloader(0);
                      let text = "This email id is already exist.";
                      if (window.confirm(text) == true) {
                      }
      
                     }
                  },
                  (error) => {
          
                  }
              );
                 
              }
      
            }, 3000);
          }
          const cancelUserConfirm = (userid) => {
            let text = "Are you sure you want to delete this user?";
            if (window.confirm(text) == true) {
            setUserAgentSoftDeleteData(userid).then(
              (data) => {
                  window.location.reload(true);
              },
              (error) => {}
            );
            }
          };
          
    return (
      <div>
        <Helmet>
          <title> User Agent @ Holiday Seychelles</title>
          <meta
            name="description"
            content="Plan your honeymoon in one of the beautiful places in the world - Holiday Seychelles."
          />
          <meta
            name="keywords"
            content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
          />
        </Helmet>
        <h1 style={{ color: "#fff" }}>
          {" "}
          User Agent @ Holiday Seychelles
        </h1>
        <NewHeader page={"inner_listing"} />
        <div className="TripContainer" id="container">
          <div
            className="reviewPlanned"
            style={{ marginTop: "-35px", height: "85px" }}
          >
            <div className="landingContainer"></div>
          </div>

          {/* <div className={this.state.ChangeColorNew}>
            <div className="tripStatusWrap">
              <ul>
                <li
                  className={this.state.Agent && "active ColorUpcoming"}
                >
                  <a className="mytripmakeFlex">
                    <span className="cm__myTripSprt--tabUpcoming cm__myTripSprt appendRight10"></span>
                    <span className="tripStatusWrap__statusText">
                      <span className="font16 latoBlack capText">
                      Booking Report
                      </span>
                      <span className="font12 latoBold"></span>
                    </span>
                  </a>
                </li>
               
              </ul>
              <div className="txtFild "></div>
            </div>
          </div> */}
          <div className="contentWrapper myTrips">
            <div>
              <div className="tripListingWrap">
                <div>
                  <div className="myTripLstngLobCrd forUpcoming">
                    <div className="Container-TileUser" style={{height: "390px !important"}}>
                      <div className="ContainerFlex">
                      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div class="container">
                          <div class="row">
                            <div className="contentWrapper"
                              style={{
                                // height: "380px",
                                overflowY: "auto",
                                width: "1100px"
                              }}
                            >
                              <div className="container">
                                <div className="row">
                                  <div class="" role="alert">
                                  <span className="font16 latoBlack capText">
                                       Create New User
                                        </span>
                                  </div>
                                  <div className="col-lg-6">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <label>Email</label>

                                      <input   type="email"
                                  className={`frmTextInput ${
                                    errors.email && "Err"
                                  }`}
                                  {...register("email", {
                                    required: true,
                                    minLength: 2,
                                    pattern:
                                      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
                                  })}
                                  id="email"
                                  name="email"
                                  placeholder="Enter Email"
                                />
                                    {errors.email &&
                                  errors.email.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Email
                                    </span>
                                  )}
                                {errors.email &&
                                  errors.email.type === "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Email must be at least 2 characters long!
                                    </span>
                                  )}
                                {errors.email &&
                                  errors.email.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter a valid email address
                                    </span>
                                  )}

                                {EmailRecheck && (
                                  <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                    This email id already exist
                                  </span>
                                )} 
                                     
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                            <div className="form-group" style={{marginBottom: '1rem'}}>
                                <label>Contact Number</label>

                                <div className="paymakeFlex textLtr" style={{display:'flex'}}>
                                    <div className="guestDtls__contact">
                                        <label for="mCode" className="frmSelectCont__contact">
                                            <select id="mCode" className="frmSelect frmSelectContact frmTextInput"   value={MobileCode}
                                  onChange={OnChangeMobileCode}>
                                          
                                    {DialCode.map((item, key) => (
                                        <option value={item.dial_code}>{item.name}&nbsp;({item.dial_code})</option>
                                    ))}
                                            </select>
                                        </label>
                                        <span className="selectedCode" id="dialCode" style={{padding: '10px'}}>
                                {MobileCode == "" ? +91: MobileCode}
                              </span>
                                        <input type="hidden" id="countryCode" name="countryCode" value={MobileCode == "" ? +91: MobileCode}/>
                                    </div>
                                    <div className="flexOne">
                                        <div className="textFieldCol ">
                                        <input
                                  type="number"
                                  className={`frmTextInput noLeftBorder frmTextInput ${
                                    errors.number && "Err"
                                  }`}
                                  {...register("number", {
                                    required: true,
                                    minLength: 6,
                                    maxLength: 15,
                                    pattern: /^[0-9]+$/i,
                                  })}
                                  id="number"
                                  name="number"
                                  placeholder="Enter Contact Number"
                                />
                               
                                {errors.number &&
                                  errors.number.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Contact Number
                                    </span>
                                  )}
                                {errors.number &&
                                  errors.number.type ===
                                    "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Contact Number must be at least 6
                                      characters long!
                                    </span>
                                  )}
                                {errors.number &&
                                  errors.number.type ===
                                    "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Contact Number should be less then 15
                                      characters !
                                    </span>
                                  )}
                                {errors.number &&
                                  errors.number.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter only number
                                    </span>
                                  )}

    
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                                  <div className="col-lg-6">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <label>First Name</label>

                                      <input
                                  type="text"
                                  className={`frmTextInput ${
                                    errors.firstName && "Err"
                                  }`}
                                  {...register("firstName", {
                                    required: true,
                                    minLength: 2,
                                    maxLength: 50,
                                    pattern: /^[A-Za-z ]+$/i,
                                  })}
                                  id="firstName"
                                  name="firstName"
                                  placeholder="Enter First Name"
                                />
                               
                                {errors.firstName &&
                                  errors.firstName.type ===
                                    "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your First Name
                                    </span>
                                  )}
                                {errors.firstName &&
                                  errors.firstName.type ===
                                    "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      First Name must be at least 2 characters
                                      long!
                                    </span>
                                  )}
                                {errors.firstName &&
                                  errors.firstName.type ===
                                    "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      First Name should be less then  50
                                      characters !
                                    </span>
                                  )}
                                {errors.firstName &&
                                  errors.firstName.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter only alphabets
                                    </span>
                                  )}
                                      
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <label>Last Name</label>
                                      <input
                                  type="text"
                                  className={`frmTextInput ${
                                    errors.lastName && "Err"
                                  }`}
                                  {...register("lastName", {
                                    required: true,
                                    minLength: 2,
                                    maxLength: 50,
                                    pattern: /^[A-Za-z ]+$/i,
                                  })}
                                  id="lastName"
                                  name="lastName"
                                  placeholder="Enter Last Name"
                                />
                                
                                {errors.lastName &&
                                  errors.lastName.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Last Name
                                    </span>
                                  )}
                                {errors.lastName &&
                                  errors.lastName.type ===
                                    "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Last Name must be at least 2 characters long!
                                    </span>
                                  )}
                                {errors.lastName &&
                                  errors.lastName.type ===
                                    "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Last Name should be less then 50 characters
                                      !
                                    </span>
                                  )}
                                {errors.lastName &&
                                  errors.lastName.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter only alphabets
                                    </span>
                                  )}
                                     
                                    </div>
                                  </div>

                                  <div className="col-lg-6">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <label> Password</label>
                                      <input
                                  type="password"
                                  className={`frmTextInput ${
                                    errors.password && "Err"
                                  }`}
                                  {...register("password", {
                                    required: true,
                                    minLength: 6,
                                    maxLength: 20,
                                  })}
                                  id="password"
                                  name="password"
                                  placeholder="Enter Password"
                                />
                                 
                                {errors.password &&
                                  errors.password.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Password
                                    </span>
                                  )}
                                {errors.password &&
                                  errors.password.type === "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Password must be at least 6 characters
                                      long!
                                    </span>
                                  )}
                                {errors.password &&
                                  errors.password.type === "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Password should be less then 20 characters !
                                    </span>
                                  )}
                                      
                                    </div>
                                  </div>

                                  <div className="col-lg-6">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <label> Confirm Password</label>
                                      <input
                                  type="password"
                                  className={`frmTextInput ${
                                    errors.confirmpassword && "Err"
                                  }`}
                                  {...register("confirmpassword", {
                                    required: true,
                                    minLength: 6,
                                    maxLength: 20,
                                    validate: value =>
                                    value === password.current || "The password do not match",
                                  })}
                                  id="confirmpassword"
                                  name="confirmpassword"
                                  placeholder="Enter  Confirm Password"
                                />
                                {errors.confirmpassword && <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>{errors.confirmpassword.message} </span>}
                                
                                {errors.confirmpassword &&
                                  errors.confirmpassword.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your  Confirm Password
                                    </span>
                                  )}
                                {errors.confirmpassword &&
                                  errors.confirmpassword.type === "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Confirm Password must be at least 6 characters
                                      long!
                                    </span>
                                  )}
                                {errors.confirmpassword &&
                                  errors.confirmpassword.type === "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Confirm Password should be less then 20 characters !
                                    </span>
                                  )}
                                     
                                    </div>
                                  </div>
                                  <div class="users-agent-form__options">
                                    <label class="users-agent-form__options-item">
                                        <input type="checkbox" {...register("checkdata")} value="active" checked disabled />
                                        <span>Active</span>
                                    </label>
                                    <label class="users-agent-form__options-item">
                                        <input type="checkbox" {...register("checkdata")} value="administrator" />
                                        <span>Administrator</span>
                                    </label>
                                    <label class="users-agent-form__options-item">
                                        <input type="checkbox" {...register("checkdata")} value="make" />
                                        <span>Make bookings</span>
                                    </label>
                                    <label class="users-agent-form__options-item">
                                        <input type="checkbox" {...register("checkdata")} value="cancel" />
                                        <span>Cancel bookings</span>
                                    </label>
                                   
                                   
                                </div>
                               
                                  <div
                                    id="pass-info"
                                    className="clearfix"
                                  ></div>
                                 <div className="col-12" style={{ marginTop: 20 }}>
                                  <div className="col-12 text-center">
                                    {" "}
                                    <button type="submit" class="primaryBtn2 appendBottom15" disabled={DisablePayNowButton} >Save &nbsp; {btnloader == 1 && (<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" visually-hidden="true"/>)}</button>
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        </form>
                      </div>
                    </div>
                    {agentUserData == "" ? (
                        <div className="emptyErr">
                          <div className="emptyErr--imgCont">
                            {/* <img src={EmptyImage} alt="Upcoming Image" /> */}
                          </div>
                          <div>
                            <p className="emptyErr--heading font22 latoBlack appendBottom15">
                              Looks empty, you've no user .
                            </p>
                            <p className="emptyErr--subHeading fomt14 darkGreyText appendBottom25">
                              When you save your user, you will see user here
                              here.
                            </p>
                            {/* <p style={{margin: 10}}>
                              <a href="/home">
                                <button className="font14 latoBold blueText myTripBtn myTripBtn--primary ">
                                  Home
                                </button>
                              </a>
                            </p> */}
                          </div>
                        </div>
                      ) : (
                        <>
                          {agentUserData == null ? (
                            <>
                              <div
                                className="Container-TileUser"
                                style={{ height: 250 }}
                              >
                                <div className="ContainerFlex">
                                  
                                  <div
                                    className="ContainerContent"
                                    style={{ padding: "10px 10px 10px 40px" }}
                                  >
                                    <div
                                      className="nameContainer"
                                      style={{ width: "100%" }}
                                    >
                                  

                                      <div class="chkContBooking">
                                        <div class="chkCont__col">
                                          <div class="paymakeFlex column">
                                            <span class="font10 grayText appendBottom3">
                                              <Skeleton
                                                style={{ width: 1000 }}
                                              />
                                            </span>
                                            <span class="latoBlack font24 blackText appendBottom3">
                                              <Skeleton
                                                style={{ width: 1000 }}
                                              />
                                            </span>
                                            <span class="font10 grayText 444">
                                              <Skeleton
                                                style={{ width: 1000 }}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="Container-TileUser">
                                <div className="ContainerFlex">
                                  <div class="container">
                                    <div class="row">
                                    <div className="landingContainer">
                                  <h4>User Listing </h4>
                                </div>
                                      <div>
                                        <table className="table table-bordered">
                                          <thead className="thead-dark">
                                            <tr>
                                            <th scope="col">#</th>
                                              <th scope="col">First Name </th>
                                              <th scope="col">Last Name </th>
                                              <th scope="col">Email</th>
                                              <th scope="col">Contact No</th>
                                              <th scope="col">Created Date</th>
                                              <th scope="col">Permissions</th>
                                              <th scope="col">Action</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                          {agentUserData &&
                                              agentUserData.map(
                                                (item, newindex) => {
                                                  return(
                                                <tr>
                                                  <th scope="row">{newindex+1}</th>
                                                  <td>{item?.user_first_name}</td>
                                                  <td>{item?.user_last_name}</td>
                                                  <td>{item?.user_email}</td>
                                                  <td>{item?.country_code} {item?.user_contact}</td>
                                                  <td>{moment(item?.created_on).format("D MMM Y")}</td>
                                                  <td> {item?.permission}</td>
                                                  <td> <NavLink
                                
                                to={
                                  "/agentuserupdate?user_id=" +
                                  item?.id +
                                  "&agent_user_first_name=" +
                                  item?.user_first_name +
                                  "&agent_user_last_name=" +
                                  item?.user_last_name +
                                  "&agent_user_email=" +
                                  item?.user_email +
                                  "&agent_user_code=" +
                                  item?.country_code +
                                  "&agent_user_mobile_number=" +
                                  item?.user_contact +
                                  "&agent_user_permission=" +
                                  item?.permission
                                }
                              >
                                {" "}
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  style={{
                                    fontSize: "14px",
                                    marginRight: "5px",
                                    cursor: "pointer",
                                    color: "#a8a8a8",
                                  }}
                                ></FontAwesomeIcon>{" "}
                              </NavLink>
                              <FontAwesomeIcon
                            icon={faTrash}
                            style={{
                              fontSize: "14px",
                              marginRight: "5px",
                              cursor: "pointer",
                              marginTop: "10px",
                              color: "#a8a8a8",
                            }}
                            onClick={() => cancelUserConfirm(item?.id)}
                          ></FontAwesomeIcon>
                              </td>
                            
                                                </tr>
                                                )})}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
   }

